import { render, staticRenderFns } from "./PreferredNameYN.vue?vue&type=template&id=5375e44d"
import script from "./PreferredNameYN.vue?vue&type=script&lang=js"
export * from "./PreferredNameYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports